module.exports = __webpack_public_path__ + "img/album4.1e52babe.jpg";